import { Component, OnInit } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';

@Component({
  selector: 'app-beneficiaries-log',
  templateUrl: './beneficiaries-log.component.html',
  styleUrls: ['./beneficiaries-log.component.scss']
})
export class BeneficiariesLogComponent implements OnInit {

  // === ESTADO DEL COMPONENTE ===
    logs: any[] = [];
    totalLogs = 0;
    currentPage = 1;
    pageSize = 20;
    loading = false;
    expandedLog: number | null = null;
    errorMessage: string | null = null;
  
    // === FILTROS ===
    filters: any = {
      logType: '',
      startDate: '',
      endDate: '',
      search: ''
    };
  
    constructor(
      public themingService: ThemingService,
      private lambdaService: LambdaService
    ) { }
  
    ngOnInit(): void {
      this.loadLogs();
    }
  
    // === CARGA DE LOGS ===
    async loadLogs() {
      this.loading = true;
      await this.lambdaService.getSaleLogs(this.themingService.shopId,"beneficiary",this.filters,this.currentPage,this.pageSize)
      .then((data: any) => {
        console.log(data.data);
        this.logs = data.data;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
      this.loading = false;
    }
  
    // === ACCIONES DE UI ===
    toggleExpand(logId: number): void {
      this.expandedLog = this.expandedLog === logId ? null : logId;
    }
  
    applyFilters(): void {
      this.currentPage = 1;
      this.loadLogs();
    }
  
    clearFilters(): void {
      this.filters = {
        logType: '',
        startDate: '',
        endDate: '',
        search: ''
      };
      this.loadLogs();
    }
  
    // formatDate(dateString: string): string {
    //   if (!dateString) return '-';
    //   return new Date(dateString).toLocaleString('es-CR', {
    //     //timeZone: 'America/Costa_Rica',
    //     year: 'numeric',
    //     month: '2-digit',
    //     day: '2-digit',
    //     hour: '2-digit',
    //     minute: '2-digit'
    //   });
    // }
  
    formatDate(dateString: string): string {
    if (!dateString) return '-';
    
    // 1. Limpiamos el string: quitamos la 'Z' y los milisegundos para evitar que JS haga conversiones
    // Ejemplo: "2026-07-24T09:20:40.000Z"  ->  "2026-07-24 09:20:40"
    const cleanString = dateString.replace('Z', '').replace('T', ' ').split('.')[0];
    
    const [datePart, timePart] = cleanString.split(' ');
    
    // Si el formato no es el esperado (ej. ya viene formateado), lo devolvemos tal cual
    if (!datePart || !timePart) return dateString; 
    
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');
    
    // 2. Convertimos a formato 12 horas manualmente
    const hourNum = parseInt(hours, 10);
    const ampm = hourNum >= 12 ? 'p. m.' : 'a. m.';
    const displayHour = hourNum % 12 || 12;
    
    // 3. Retornamos el formato deseado sin que JavaScript haya aplicado ninguna zona horaria
    return `${day}/${month}/${year}, ${displayHour.toString().padStart(2, '0')}:${minutes} ${ampm}`;
  }
    getStatusBadgeClass(logType: string): string {
      switch (logType) {
        case 'SALE_PAYMENT_SUCCESS': return 'bg-success';
        case 'SALE_PAYMENT_FAILED': return 'bg-danger';
        case 'SALE_STATE_CHANGED': return 'bg-info';
        default: return 'bg-secondary';
      }
    }
  
    getStatusText(logType: string): string {
      switch (logType) {
        case 'SALE_PAYMENT_SUCCESS': return 'Exitoso';
        case 'SALE_PAYMENT_FAILED': return 'Fallido';
        case 'SALE_STATE_CHANGED': return 'Cambio de estado';
        default: return logType;
      }
    }
  
    copyToClipboard(content: any): void {
      const text = typeof content === 'string' ? content : JSON.stringify(content, null, 2);
      navigator.clipboard.writeText(text).then(() => {
        // Opcional: mostrar toast de confirmación
        console.log('Copiado al portapapeles');
      });
    }
  
    // === PAGINACIÓN ===
    get totalPages(): number {
      return Math.ceil(this.totalLogs / this.pageSize);
    }
  
    getPagesArray(): number[] {
      const pages: number[] = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);
      
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  
    goToPage(page: number): void {
      if (page < 1 || page > this.totalPages || page === this.currentPage) return;
      this.currentPage = page;
      this.loadLogs();
    }
  
    // === UTILIDADES PARA JSON ===
    isJsonEmpty(obj: any): boolean {
      return !obj || Object.keys(obj).length === 0;
    }

}
